import {MailItemContentType} from "../../Types/MailItemTypes";
import {MailItemContents} from "./Components/MailItemContents";
import {MailItemMeta} from "./Components/MailItemMeta";
import {SentInfo} from "./Components/SentInfo";

const SentMailItemContent = (props: MailItemContentType) => {
    return (
        <div className={'row'}>
            <div className={'col-xs-12 col-lg-4 col-xl-3'}>
                <MailItemMeta mailboxTopBarHeight={props.mailboxTopBarHeight}/>
            </div>
            <div className={'col-xs-12 col-lg-8 col-xl-9'}>
                <SentInfo />
                <MailItemContents />
            </div>
        </div>
    )
}

export {SentMailItemContent}
